module.exports = __webpack_public_path__ + "static/media/rocketppe_kn95_mob.97d2df34.jpg";